const isTruthy = (value: unknown) => {
  return value ? true : false
}

export default isTruthy
